// extracted by mini-css-extract-plugin
export default {"background":"SlidingMenu_background__9lQq9","body":"SlidingMenu_body__qVwmi","footerNames":"SlidingMenu_footerNames__a9hDu","shadow":"SlidingMenu_shadow__S2tBQ"};